module.exports = __webpack_public_path__ + "static/img/3.d61b5bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.png
// module id = U+2z
// module chunks = 0